import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33f3a404"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-white mt-4" }
const _hoisted_2 = { class: "card-body text-center" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "font-size-14 d-block" }
const _hoisted_5 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "card-footer d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    class: "theme-1",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
    onHide: _ctx.onClose,
    position: "top"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "font-size-14 d-block",
            innerHTML: _ctx.dialogDeleteState?.message
          }, null, 8, _hoisted_3),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.dialogDeleteState?.payload?.rowIndex), 1),
          (_ctx.requiresTextConfirmation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", {
                  class: "font-size-13 d-block mb-2",
                  innerHTML: _ctx.$t('main.confirmationDeleteDialog.typeToConfirm', { text: _ctx.expectedConfirmationText })
                }, null, 8, _hoisted_6),
                _createVNode(_component_q_input, {
                  modelValue: _ctx.confirmationValue,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmationValue) = $event)),
                  dense: "",
                  outlined: "",
                  autofocus: "",
                  placeholder: _ctx.expectedConfirmationText
                }, null, 8, ["modelValue", "placeholder"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_q_btn, {
            class: "btn text-body mr-2",
            color: "transparent",
            label: _ctx.$t('main.confirmationDeleteDialog.cancelButton'),
            onClick: _ctx.onCancel
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_q_btn, {
            class: "btn btn-primary",
            label: _ctx.$t('main.confirmationDeleteDialog.confirmationButton'),
            disable: _ctx.requiresTextConfirmation && !_ctx.isConfirmationValueValid,
            onClick: _ctx.onConfirm
          }, null, 8, ["label", "disable", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onHide"]))
}